import {axios} from "~/plugins/axios";

const getDefaultState_KlnByOperators = () => {
  return {
    items: [],
  }
}
const state = getDefaultState_KlnByOperators();

const getters = {}

const actions = {
  async loadKlnByOperatorsReport({ commit }, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      const response = await axios.post('/api/reports/complaints/statistics-kln-by-operators', payload)
        .catch(error => {console.error(error)})
      return response.data
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      throw err
    } finally {
      commit('shared/SET_LOADING', false, {root: true})
    }
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
